class BlogArticlesLoader extends HTMLElement {
  constructor() {
    super()

    this.articlesContainer = this.querySelector('[data-articles-container]')
    this.spinner = this.querySelector('.blog-articles__spinner')
    this.loadMoreBtn = this.querySelector('[data-load-more-btn]')
    this.lastCursor = ''
    this.hasNextPage = false

    this.fetchArticles = this.fetchArticles.bind(this)
    this.renderArticles = this.renderArticles.bind(this)
    this.handleLoadMore = this.handleLoadMore.bind(this)
  }

  connectedCallback() {
    // Set button label from attribute or default

    this.loadMoreBtn.addEventListener('click', this.handleLoadMore)
    this.renderArticles()
  }

  disconnectedCallback() {
    this.loadMoreBtn.removeEventListener('click', this.handleLoadMore)
  }

  async fetchArticles() {
    const articleCount = this.getAttribute('data-count') || 9
    const shopName = this.getAttribute('data-shop')
    const apiVersion = this.getAttribute('data-api-version')
    const accessToken = this.getAttribute('data-access-token')
    const blogHandle = this.getAttribute('data-blog-handle')

    const articleBody = `
      nodes {
        title
        author { name }
        blog { handle }
        handle
        image { altText height width url }
        content
        excerpt
      }
      pageInfo { endCursor hasNextPage }
    `

    const articlesQuery = this.lastCursor
      ? `articles(sortKey: PUBLISHED_AT, reverse: true, first: ${articleCount}, after: "${this.lastCursor}") { ${articleBody} }`
      : `articles(sortKey: PUBLISHED_AT, reverse: true, first: ${articleCount}) { ${articleBody} }`

    const query =
      blogHandle && blogHandle.length > 0
        ? `
      query {
        blog(handle: "${blogHandle}") {
          ${articlesQuery}
        }
      }`
        : `
      query {
        ${articlesQuery}
      }
    `

    const url = `https://${shopName}.myshopify.com/api/${apiVersion}/graphql.json`

    try {
      this.articlesContainer.classList.add('loading')
      this.loadMoreBtn.disabled = true

      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': accessToken,
        },
        body: JSON.stringify({ query }),
      })

      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`)

      const responseData = await response.json()
      const articlesData = responseData.data?.blog?.articles ?? responseData.data?.articles

      if (articlesData?.pageInfo?.hasNextPage) {
        this.lastCursor = articlesData.pageInfo.endCursor
        this.hasNextPage = true
        this.loadMoreBtn.style.display = 'block'
      } else {
        this.lastCursor = ''
        this.hasNextPage = false
        this.loadMoreBtn.style.display = 'none'
      }
      return articlesData?.nodes || []
    } catch (error) {
      console.error('Error fetching articles:', error.message)
      return []
    } finally {
      this.articlesContainer.classList.remove('loading')
      this.loadMoreBtn.disabled = false
    }
  }

  async renderArticles() {
    const articles = await this.fetchArticles()
    let articlesHtml = ''
    for (let article of articles) {
      if (window.location.pathname.includes('/blogs/') && window.location.pathname.includes('press')) {
        articlesHtml += `
        <a 
          href="${article?.content}" 
          class="blog-articles__article"
        >
          <div class="blog-articles__article-image__wrapper">
            <img 
              src="${article.image?.url || ''}"
              alt="${article.image?.altText || article.title}"
            />
          </div>
        </a>
      `
      } else {
        articlesHtml += `
        <a 
          href="/blogs/${article.blog.handle}/${article.handle}" 
          class="blog-articles__article"
        >
          <div class="blog-articles__article-image__wrapper">
            <img 
              src="${article.image?.url || ''}"
              alt="${article.image?.altText || article.title}"
            />
          </div>
          <h4 class="blog-articles__article-title">
            ${article?.title}
          </h4>
          ${
            article?.excerpt || article?.content
              ? `
              <p class="blog-articles__article-excerpt">
                ${article?.excerpt || article?.content}
              </p>  
            `
              : ''
          }
        </a>
      `
      }
    }
    this.articlesContainer.innerHTML += articlesHtml
  }

  handleLoadMore() {
    this.renderArticles()
  }
}

customElements.define('blog-articles-loader', BlogArticlesLoader)
